import { Api } from "../config/request";

export default {
  getUploadUrl(payload) {
    return Api.post("/upload-doc/presigned-url", payload);
  },
};
